/* tslint:disable */
/* eslint-disable */
/**
 * Jobs 24/7
 * Jobs 24/7
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: shraaliya0802@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AddCategoryRequest,
  AddDomain200Response,
  AddDomainRequest,
  AddSubcategoryRequest,
  Domain,
} from '../models/index';
import {
    AddCategoryRequestFromJSON,
    AddCategoryRequestToJSON,
    AddDomain200ResponseFromJSON,
    AddDomain200ResponseToJSON,
    AddDomainRequestFromJSON,
    AddDomainRequestToJSON,
    AddSubcategoryRequestFromJSON,
    AddSubcategoryRequestToJSON,
    DomainFromJSON,
    DomainToJSON,
} from '../models/index';

export interface AddCategoryOperationRequest {
    body: AddCategoryRequest;
}

export interface AddDomainOperationRequest {
    body: AddDomainRequest;
}

export interface AddSubcategoryOperationRequest {
    body: AddSubcategoryRequest;
}

export interface DeleteCategoryRequest {
    id: number;
}

export interface DeleteDomainRequest {
    id: number;
}

export interface DeleteSubcategoryRequest {
    id: number;
}

/**
 * 
 */
export class DomainApi extends runtime.BaseAPI {

    /**
     * Add a new category
     */
    async addCategoryRaw(requestParameters: AddCategoryOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AddDomain200Response>> {
        if (requestParameters['body'] == null) {
            throw new runtime.RequiredError(
                'body',
                'Required parameter "body" was null or undefined when calling addCategory().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/category/add`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddCategoryRequestToJSON(requestParameters['body']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AddDomain200ResponseFromJSON(jsonValue));
    }

    /**
     * Add a new category
     */
    async addCategory(requestParameters: AddCategoryOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AddDomain200Response> {
        const response = await this.addCategoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Add a new domain
     */
    async addDomainRaw(requestParameters: AddDomainOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AddDomain200Response>> {
        if (requestParameters['body'] == null) {
            throw new runtime.RequiredError(
                'body',
                'Required parameter "body" was null or undefined when calling addDomain().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/domain/add`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddDomainRequestToJSON(requestParameters['body']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AddDomain200ResponseFromJSON(jsonValue));
    }

    /**
     * Add a new domain
     */
    async addDomain(requestParameters: AddDomainOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AddDomain200Response> {
        const response = await this.addDomainRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Add a new subcategory
     */
    async addSubcategoryRaw(requestParameters: AddSubcategoryOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AddDomain200Response>> {
        if (requestParameters['body'] == null) {
            throw new runtime.RequiredError(
                'body',
                'Required parameter "body" was null or undefined when calling addSubcategory().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/subcategory/add`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddSubcategoryRequestToJSON(requestParameters['body']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AddDomain200ResponseFromJSON(jsonValue));
    }

    /**
     * Add a new subcategory
     */
    async addSubcategory(requestParameters: AddSubcategoryOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AddDomain200Response> {
        const response = await this.addSubcategoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a category
     */
    async deleteCategoryRaw(requestParameters: DeleteCategoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AddDomain200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteCategory().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/category/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AddDomain200ResponseFromJSON(jsonValue));
    }

    /**
     * Delete a category
     */
    async deleteCategory(requestParameters: DeleteCategoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AddDomain200Response> {
        const response = await this.deleteCategoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a domain
     */
    async deleteDomainRaw(requestParameters: DeleteDomainRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AddDomain200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteDomain().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/domain/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AddDomain200ResponseFromJSON(jsonValue));
    }

    /**
     * Delete a domain
     */
    async deleteDomain(requestParameters: DeleteDomainRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AddDomain200Response> {
        const response = await this.deleteDomainRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a subcategory
     */
    async deleteSubcategoryRaw(requestParameters: DeleteSubcategoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AddDomain200Response>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteSubcategory().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/subcategory/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AddDomain200ResponseFromJSON(jsonValue));
    }

    /**
     * Delete a subcategory
     */
    async deleteSubcategory(requestParameters: DeleteSubcategoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AddDomain200Response> {
        const response = await this.deleteSubcategoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * get all domain and relations
     */
    async getAllDomainsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Domain>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/domain/all`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DomainFromJSON));
    }

    /**
     * get all domain and relations
     */
    async getAllDomains(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Domain>> {
        const response = await this.getAllDomainsRaw(initOverrides);
        return await response.value();
    }

}
